module.exports = __webpack_public_path__ + "static/media/shopby.53ead8e3.webp";